import { render, staticRenderFns } from "./FileSplit.vue?vue&type=template&id=481c950a&scoped=true"
import script from "./FileSplit.vue?vue&type=script&lang=js"
export * from "./FileSplit.vue?vue&type=script&lang=js"
import style0 from "./FileSplit.vue?vue&type=style&index=0&id=481c950a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c950a",
  null
  
)

export default component.exports